import InvestUnitSmall from '@/src/components/AppComponents/InvestUnit/InvestUnitSmall/InvestUnitSmall';
import { FundWithDetailsEntity } from '@/src/lib/MayzSmartDB';
import { useTokensStore } from '@/src/store/global';
import { getNumberx1e6, hexToStr } from '@/src/lib/MayzSmartDB';
import { formatPercentage } from '@/src/lib/SmartDB/Commons/formatters';
import { showADA_Amount_Rounded, showTokenGov_Amount_Rounded, showToken_Price_Rounded } from '@/src/store/global/tokensStoreModelHelpers';
import { CHEVRON_DOWN } from "@/src/lib/SmartDB/Commons/Constants/images";
import { Fragment, useEffect, useState } from 'react';
import RowDetailsHome from './RowDetailsHome';
import styles from './TableHome.module.scss';
import { isWebsiteDApp } from '@/src/utils/constants';

type PropsFundTable = {
    current?: FundWithDetailsEntity;
    funds: FundWithDetailsEntity[];
    isTablet: boolean;
    isLoading: boolean;
    isMobile: boolean;
    id?: string;
};

export default function FundsTableHome(props: PropsFundTable) {
    //--------------------------------------
    const [isRefreshing, setIsRefreshing] = useState(true);
    //--------------------------------------
    useEffect(() => {
        setIsRefreshing(false);
    }, []);
    //--------------------------------------
    const { current, funds, isTablet, isMobile, isLoading, id } = props;
    //--------------------------------------
    const tokensStore = useTokensStore();
    //--------------------------------------
    const [openRowId, setOpenRowId] = useState<string | null>(null);
    //--------------------------------------
    const handleClickOpen = (fundId: string) => {
        if (openRowId === fundId) {
            setOpenRowId(null);
        } else {
            setOpenRowId(fundId);
        }
    };
    const skeletonData = Array(5)
        .fill(null)
        .map((_, index) => ({
            _DB_id: index,
        }));

    //--------------------------------------
    return (
        <main className={`${styles.table}`}>
            <section className={styles.thead}>
                <article className={`${styles.rowItem} ${styles.fundsTokens}`}>Fund</article>
                <article className={`${styles.rowItem} ${styles.price}`}>Price</article>
                {!isMobile && <article className={`${styles.rowItem} ${styles.change}`}>Change 24h</article>}
                {!isTablet && (
                    <>
                        <article className={`${styles.rowItem} ${styles.tvl}`}>TVL</article>
                        {isWebsiteDApp && <article className={`${styles.rowItem} ${styles.delegated}`}>Staked</article>}
                    </>
                )}
                <article className={`${styles.rowItem} ${styles.chevron}`}></article>
            </section>
            {isLoading || isRefreshing ? (
                <section className={styles.tbody}>
                    {skeletonData.map((fund) => (
                        <Fragment key={fund._DB_id}>
                            <article className={`${styles.row} ${styles.rowSkeleton}`}></article>
                        </Fragment>
                    ))}
                </section>
            ) : funds.length === 0 ? (
                <section className={styles.tbody}>
                    <article className={`${styles.row} ${styles.rowEmpty}`}>
                        <p className={styles.text}>Not funds found</p>
                        <div className={styles.background}></div>
                    </article>
                </section>
            ) : (
                <section className={styles.tbody}>
                    {funds.map((fund) => (
                        <Fragment key={fund._DB_id}>
                            <article
                                className={`${styles.row} ${openRowId === fund._DB_id ? styles.open : ''} ${id === fund._DB_id ? styles.active : ''}`}
                                onClick={() => handleClickOpen(fund._DB_id)}
                            >
                                <div className={`${styles.rowItem} ${styles.fundsTokens}`}>
                                    <InvestUnitSmall investUnitWithDetails={fund.investUnit} />
                                    <p className={styles.name}>
                                        {fund.name} [{hexToStr(fund.fdFundFT_TN_Hex)}]
                                    </p>
                                </div>
                                <div className={`${styles.rowItem} ${styles.price}`}>{showToken_Price_Rounded(tokensStore, fund.getNET_id_CS(), fund.fdFundFT_TN_Hex)}</div>
                                {!isMobile && (
                                    <div
                                        className={`${styles.rowItem} ${styles.change} ${
                                            fund.change24 !== undefined ? (fund.change24 < 0 ? styles.negative : styles.positive) : styles.positive
                                        }`}
                                    >
                                        {fund.change24 !== undefined ? formatPercentage(fund.change24, 2) : '...'}
                                    </div>
                                )}
                                {!isTablet && (
                                    <>
                                        <article className={`${styles.rowItem} ${styles.tvl}`}>{showADA_Amount_Rounded(tokensStore, getNumberx1e6(fund.TVLx1e6))}</article>
                                        {isWebsiteDApp && (
                                            <article className={`${styles.rowItem} ${styles.delegated}`}>{showTokenGov_Amount_Rounded(tokensStore, fund.staked)}</article>
                                        )}
                                    </>
                                )}
                                <div className={`${styles.rowItem} ${styles.chevron}`}>
                                    <svg width="16" height="16" id="icon" className={styles.icon}>
                                        <use href={CHEVRON_DOWN}></use>
                                    </svg>
                                </div>
                            </article>
                            {openRowId === fund._DB_id && <RowDetailsHome fund={fund} isTablet={isTablet} isMobile={isMobile} />}
                        </Fragment>
                    ))}
                </section>
            )}
        </main>
    );
}
